import { useEffect } from 'react'
import generalSelectors from 'models/General/selectors'
import { useSelector } from 'react-redux'

import PrimaryLink from 'units/PrimaryLink'

import { sendAnalyticsEvent } from 'services/analytics'
import { intercomShowNewMessage } from 'services/Intercom'

import { EVENT_TYPE, SUPPORT_EMAIL, STRING } from 'resources'
import { INTERCOM_KB_URLS } from 'resources/urls'

import {
  Container,
  CardDescription,
  Title,
  SupportLink,
  ButtonContainer,
  SupportRegionButton,
  ContactSupportButton,
  DescriptionPadded,
} from './styles'

const RegionNotSupported = () => {
  const detectedRegion = useSelector(generalSelectors.getRegion)
  const detectedIpAddress = useSelector(generalSelectors.getIpAddress)

  const openIntercomMessage = () => {
    intercomShowNewMessage(STRING.networkError.supportInitialMessage(detectedRegion, detectedIpAddress))
  }
  useEffect(() => {
    sendAnalyticsEvent(EVENT_TYPE.regionErrorView, {
      Region: detectedRegion,
      IpAddress: detectedIpAddress,
    })
  }, [detectedRegion, detectedIpAddress])

  return (
    <Container>
      <Title>{STRING.networkError.regionNotSupported.title}</Title>
      <CardDescription>
        <DescriptionPadded>{STRING.networkError.regionNotSupported.description1}</DescriptionPadded>
        <span>{STRING.networkError.regionNotSupported.description2}</span>
        <SupportLink href={`mailto:${SUPPORT_EMAIL}`} target="_blank" rel="noopener noreferrer">
          {SUPPORT_EMAIL}
        </SupportLink>
      </CardDescription>
      <CardDescription>
        <DescriptionPadded>
          {STRING.networkError.regionNotSupported.detectedRegion}
          <b>{detectedRegion || STRING.networkError.regionNotSupported.notApplicable}</b>
        </DescriptionPadded>
        <DescriptionPadded>
          {STRING.networkError.regionNotSupported.ipAddress}
          <b>{detectedIpAddress || STRING.networkError.regionNotSupported.notApplicable}</b>
        </DescriptionPadded>
      </CardDescription>
      <ButtonContainer>
        <SupportRegionButton tag={PrimaryLink} to={INTERCOM_KB_URLS.SUPPORTED_REGIONS}>
          {STRING.networkError.regionNotSupported.button}
        </SupportRegionButton>
        <ContactSupportButton
          variant="secondary"
          onPress={openIntercomMessage}
          buttonText={STRING.networkError.regionNotSupported.contactSupportButton}
        />
      </ButtonContainer>
    </Container>
  )
}

export default RegionNotSupported
